export default __webpack_public_path__ + "static/media/prothetik_01.7e8dd8ee.png";